import React, { useState } from "react";

const BurnTable = ()=>{
    const [tableDrop, setTableDrop] = useState(false);
    return(
        <>
        <section className="_explore_table_sec">
                <div className="_explore_table_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div onClick={()=>{setTableDrop(!tableDrop)}} className="_explore_table_item_drop">
                                    <span className="_explore_table_item_drop_ic1"><svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} fill="none" viewBox="0 0 38 37">
                                        <path fill="#11142D" d="M9.045 36.104a1.35 1.35 0 0 0 1.91 0l8.59-8.591a1.35 1.35 0 0 0-1.908-1.91L10 33.24l-7.637-7.636a1.35 1.35 0 0 0-1.909 1.909l8.591 8.591ZM8.65 1.85v33.3h2.7V1.85h-2.7ZM28.955.895a1.35 1.35 0 0 0-1.91 0l-8.59 8.591a1.35 1.35 0 0 0 1.908 1.91L28 3.759l7.637 7.637a1.35 1.35 0 1 0 1.909-1.91L28.955.896Zm.395 34.255V1.85h-2.7v33.3h2.7Z" />
                                    </svg>
                                    </span>
                                    <p className="_explore_table_item_drop_txt">Item Activity</p>
                                    <span className="_explore_table_item_drop_ic2"><svg xmlns="http://www.w3.org/2000/svg" width={20} height={14} fill="none" viewBox="0 0 31 19">
                                        <path fill="#1F1F1F" d="M31 2.677 28.471 0 15.5 13.732 2.529 0 0 2.677 15.5 19 31 2.677Z" />
                                    </svg>
                                    </span>
                                </div>
                                <div className={`_explore_table_item_dropdown ${tableDrop?'active':''}`}>
                                    <select id="_explore_filter">
                                        <option className="_explore_filter_option">Sales</option>
                                        <option className="_explore_filter_option">Token</option>
                                        <option className="_explore_filter_option">Rate</option>
                                    </select>
                                    {/* <img src="assets/img/sales.svg" alt="chobi" className="_explore_filter_option_show" /> */}
                                    <div className="_explore_filter_option_show">
                                        <p className="_explore_filter_option_show_p">sales</p>
                                        <div className="_explore_filter_option_close">
                                            x
                                        </div>
                                    </div>
                                    <div className="_explore_table_item_dropdown_table">
                                        <ul className="_explore_table_item_dropdown_table_head_ul">
                                            <li className="_explore_table_item_dropdown_table_head_li">
                                                Event
                                            </li>
                                            <li className="_explore_table_item_dropdown_table_head_li">
                                                Price
                                            </li>
                                            <li className="_explore_table_item_dropdown_table_head_li">
                                                From
                                            </li>
                                            <li className="_explore_table_item_dropdown_table_head_li">
                                                To
                                            </li>
                                            <li className="_explore_table_item_dropdown_table_head_li">
                                                Date
                                            </li>
                                        </ul>
                                        <div className="_explore_table_item_dropdown_table_ul_wrap">
                                            <ul className="_explore_table_item_dropdown_table_ul">
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    Burn
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    1.5 ETH
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    You
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    You
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    04/12/2022
                                                </li>
                                            </ul>
                                            <ul className="_explore_table_item_dropdown_table_ul">
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    <span className="_explore_table_item_dropdown_table_li_ic">
                                                        
                                                    </span>
                                                    Mint
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    1.5 ETH
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    You
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    You
                                                </li>
                                                <li className="_explore_table_item_dropdown_table_li">
                                                    04/12/2022
                                                </li>
                                            </ul>
                                        </div>
                                        {/* <img src="assets/img/exploretable.svg" alt="chobi" className="_explore_table_item_dropdown_table_img" /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default BurnTable;